// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUsers, IconDeviceAnalytics, IconLayoutDashboard } from '@tabler/icons-react';

const icons = {
    IconUsers,
    IconDeviceAnalytics,
    IconLayoutDashboard
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const userManagement = {
    id: 'User Management',
    title: <FormattedMessage id="User Management" />,
    icon: icons.IconUsers,
    type: 'group',
    children: [
        {
            id: 'Users',
            title: <FormattedMessage id="Users" />,
            type: 'item',
            url: '/users/list',
            icon: icons.IconUsers,
            breadcrumbs: false
        },
    ]
};

export default userManagement;
